import React, {useEffect, useState} from 'react';
import './styles.scss';
import * as Yup from 'yup';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Column, Row} from '../../components/layout';
import Header1 from '../../components/headers/header1';
import * as fonts from '../../util/fonts';
import colors from '../../util/colors';
import {
  addToWizard,
  setMedicoOnlineEnabled,
  setWizard,
} from '../../store/actions';
import Icon from '../../components/icon/index';
import {Icons} from '../../util/icons';
import {LocationPinIcon} from './LocationPinIcon';
import {
  AppForm,
  AppFormField,
  AppFormCheckboxField,
  AppFormSubmitButton,
} from '../../components/forms';
import {useMediaQuery} from 'react-responsive';
import ModalTemplate from '../../components/modal';
import AppButton from '../../components/app-button/index';
import {getWithCustomHeaders, get} from '../../api/api';
import {
  uriGetClinicProcedure,
  uriGetLocations,
  uriGetNetwork,
  uriGetNetworkSearch,
  uriGetClinicProcedureAlpha,
  uriGetClinicGroup,
  uriGetClinicGroupAlpha,
  uriGetServices,
} from '../../api/endpoints';
import NewResults from './components/Results/Stage1/NewResults';
import AppSpinner from '../../components/app-spinner/index';
import Stage2Medics from './components/Results/Stage2/Stage2Medics';
import Stage2Clinics from './components/Results/Stage2/Stage2Clinics';
import NewStage2 from './components/Results/Stage2/NewStage2';
import {filterActiveCategories, getColor} from '../../util/utility';
import {useHistory} from 'react-router-dom';
import ArrowIcon from './ArrowIcon';
import {LoadScript} from '@react-google-maps/api';

const WINDOW_DIMENSION_LIMIT = 768;

interface MedicalNetworkProps {
  buStyles: any;
  selectedBu: any;
  user: any;
  labelsRede: typeof strings.pt.rede;
  labelsAppointments: typeof strings.pt.appointments;
  labelsPrecos: typeof strings.pt.redePrecos;
  oneTrust: typeof strings.pt.oneTrust;
  purposes: any;
  showCardModal: any;
  busFuncMap: any;
  consultasOnlineEnabled: any;
  accessToken: any;
  medicoOnlineEnabled: any;
  setMedicoOnlineEnabled: Function;
}

interface Network {
  count: any;
  networks: {
    category: any;
    code: any;
    description: any;
    logo: any;
    name: any;
    netCode: any;
    hash: any;
    checked: boolean;
  }[];
}

function NewMedicalNetwork({
  buStyles,
  oneTrust,
  labelsRede,
  labelsAppointments,
  labelsPrecos,
  selectedBu,
  showCardModal,
  busFuncMap,
  consultasOnlineEnabled,
  accessToken,
  medicoOnlineEnabled,
  setMedicoOnlineEnabled,
}: MedicalNetworkProps) {
  const validationSchema = Yup.object().shape({});

  //States to show Components
  const [showDropDown, setShowDropDown] = useState(false);
  const [showAutoComplete, setShowAutoComplete] = useState(false);
  const [showChangeCard, setShowChangeCard] = useState(false);
  const [clinicClicked] = useState(false);
  const isResponsive = useMediaQuery({maxDeviceWidth: 768});
  const [firstSelectedBu, setFirstSelectedBu] = useState(selectedBu);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingResults, setIsLoadingResults] = useState(false);
  const [networkReady, setNetworkReady] = useState(false);
  const [locationsReady, setLocationsReady] = useState(false);
  const [currentFilter, setCurrentFilter] = useState('');
  const [showMedicOnlineBanner, setShowMedicOnlineBanner] = useState(false);
  const [localHistory, setLocalHistory]: any[] = useState([]);
  const [showPriceResults, setShowPriceResults] = useState(false);
  const [shouldShowMap, setShouldShowMap] = useState(false);
  const [mobileMode, setMobileMode] = useState(false);
  const [networkError, setNetworkError] = useState(false);
  //States to save values of api calls/state change
  const [medics, setMedics]: any = useState();
  const [clinics, setClinics]: any = useState();
  const [optics, setOptics]: any = useState();
  const [locations, setLocations] = useState([]);
  const [wellBeing, setWellBeing]: any = useState();
  const [alternativeKeywords, setAlternativeKeywords]: any = useState();
  const [finalNetworks, setFinalNetworks] = useState([]);
  const [paginationCode, setPaginationCode]: any = useState();
  const [searchResults, setSearchResults]: any = useState();
  const [searchClicked, setSearchClicked]: any = useState();
  const [resultCount, setResultCount] = useState(0);
  const [resultCategories, setResultCategories]: any = useState();
  const [network, setNetwork]: any[] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSearch, setCurrentSearch] = useState('');
  const [selectedCategoryCode, setSelectedCategoryCode] = useState(-1);
  const [selectedSpecialtyCode, setSelectedSpecialtyCode] = useState(-1);
  const [filterTab, setFilterTab] = useState(false);
  const [selectedMedicCode, setSelectedMedicCode] = useState();
  const [selectedClinicCode, setSelectedClinicCode] = useState();
  const [selectedClinicSection, setSelectedClinicSection] = useState();
  const [returnHeaderSearchField, setReturnHeaderSearchField] = useState('');
  const [medicDataFromSpeciality, setMedicDataFromSpeciality]: any = useState();
  const [triggeredViewMore, setTriggeredViewMore] = useState(false);

  //AutoComplete & Network Checkboxes
  const [searchFieldAutoComplete, setSearchFieldAutoComplete] = useState('');
  const [searchSuggestions, setSearchSuggestions] = useState<string[]>([]);
  const [networkChecked, setNetworkChecked]: any[] = useState([]);
  const [searchFields, setSearchFields]: any = useState();
  const [selectAllFilters, setSelectAllFilters] = useState(true);

  const [medicalNetworkIsVisible, setMedicalNetworkIsVisible] = useState(
    busFuncMap?.[selectedBu?.buId]?.find(
      (el: any) => el.featureTemplateAlias === functionalitiesAliasMap?.rede
    )?.isVisible
  );

  const featureName = 'MedicalNetwork';

  const [valid, setValid] = useState(false);
  const [whatYouSearchFilled, setWhatYouSearchFilled] = useState(false);
  const [countryDistrictFilled, setCountryDistrictFilled] = useState(false);
  const enabledButton =
    whatYouSearchFilled &&
    countryDistrictFilled &&
    !(networkChecked?.length === 0 && !selectAllFilters) &&
    !isLoadingResults;

  const token = accessToken;
  const precoEstimadoFunc = busFuncMap[selectedBu.buId].find(
    (item: any) =>
      item.featureTemplateAlias === functionalitiesAliasMap?.redePrecos
  );
  const precoEstimadoFuncAtiva = precoEstimadoFunc
    ? precoEstimadoFunc?.isVisible
    : false;

  const precoEstimadoAtivo = precoEstimadoFuncAtiva;

  //header não tem o Member: memId para returnar todas as networks em vez de apenas as que aparecem com o memId do utilizador
  const headers =
    labelsRede?.medicalNetwork_toggleHeaders === 'true'
      ? {
          Unit: selectedBu.buId,
          Family: selectedBu.famId,
          Fiscal: selectedBu.nif,
          Authorization: 'Bearer ' + token,
          Member: selectedBu.memId,
        }
      : undefined;
  const history = useHistory();

  //get networks for checkbox
  async function getNetwork() {
    try {
      return await getWithCustomHeaders(
        uriGetNetwork(),
        headers,
        false,
        true,
        settingError
      );
    } catch (e: any) {
    } finally {
      setNetworkReady(true);
    }
  }
  //get locations for autocomplete: calls API, saves all results then search for matches in autocomplete
  async function getLocations() {
    try {
      return await getWithCustomHeaders(
        uriGetLocations(),
        headers,
        false,
        true,
        settingError
      );
    } catch (e: any) {
    } finally {
      setLocationsReady(true);
    }
  }

  async function searchBoxEventListener() {
    //closes the autocomplete popup when clicked outside of it/opens it when clicked in the field
    window.addEventListener('click', function (e) {
      const clickedAutoCompleteToggle = document
        .getElementById('auto-complete')
        ?.contains(e.target as any);
      const clickedAutoComplete = document
        .getElementById('open-auto-complete')
        ?.contains(e.target as any);
      const clickedDropDownToggle = document
        .getElementById('network-dropdown-toggle')
        ?.contains(e.target as any);
      const clickedDropdown = document
        .getElementById('network-dropdown')
        ?.contains(e.target as any);
      //TODO: refine this
      const clickedCheckbox =
        ((e.target as any).tagName === 'path' ||
          (e.target as any).tagName === 'svg') &&
        (e as any).pageY < 800;

      if (clickedAutoCompleteToggle || clickedAutoComplete) {
        // Clicked in box´
        setShowAutoComplete(true);
      } else {
        setShowAutoComplete(false);
        // Clicked outside the box
      }

      //closes networkDropdown if clicked outisde of the dropdown
      if (clickedDropDownToggle || clickedDropdown || clickedCheckbox) {
        if (
          !((e.target as any).tagName === 'svg') &&
          (e.target as any).id !== 'estimated-price'
        ) {
          //returns svg when clicking in a checked checkbox, this condition is to be able to close the dropdown when clicking in the "redes" anchor inside the dropdown without compromising the parent condition
          setShowDropDown(true);
        }
      } else {
        setShowDropDown(false);
      }
    });
  }

  const medicBanner = (searchedFieldValue: any) => {
    if (searchedFieldValue) {
      const medicOnlineKeywords =
        labelsRede?.medicalNetwork_medicOnlineBanner_keywords?.split(',');
      let correspondence = medicOnlineKeywords?.find(
        (keyword) => keyword.toLowerCase() === searchedFieldValue.toLowerCase()
      );
      if (correspondence) {
        setShowMedicOnlineBanner(true);
      } else {
        setShowMedicOnlineBanner(false);
      }
    }
  };

  const settingError = (error: boolean) => {
    setNetworkError(error);
  };

  useEffect(() => {
    setIsLoading(true);
    //copy the network checkboxes to an array the represents which are checked (initial state: all checked)
    getNetwork().then((res: any) => {
      let networksFinal = res?.data?.networks?.filter(
        (e: any) => e.visible === 1
      );
      setNetwork(networksFinal);
      let checkboxValues = networksFinal?.map((el: any) => {
        return el.code;
      });
      setNetworkChecked(checkboxValues);
    });

    getLocations().then((res: any) => {
      setLocations(res?.data?.locations);
    });

    searchBoxEventListener();
    setFirstSelectedBu(selectedBu);
  }, []);

  useEffect(() => {
    const medicalNetwork = busFuncMap?.[selectedBu?.buId]?.find(
      (el: any) => el.featureTemplateAlias === functionalitiesAliasMap?.rede
    )?.isVisible;
    setMedicalNetworkIsVisible(medicalNetwork);
  }, [selectedBu]);

  useEffect(() => {
    if (networkReady && locationsReady) {
      setIsLoading(false);
    }
  }, [networkReady, locationsReady]);

  //UseEffect for when a card is changed and the search need to be reset (triggers popup)
  useEffect(() => {
    if (
      firstSelectedBu.memId !== selectedBu.memId &&
      !showCardModal.showCardSelector
    ) {
      setFirstSelectedBu(selectedBu);
      setShowChangeCard(true);
    }
  }, [selectedBu, showCardModal.showCardSelector]);

  useEffect(() => {
    const getServices = async () => {
      try {
        await get(
          uriGetServices(selectedBu.buId, selectedBu.prdNbr, selectedBu.benNbr),
          false,
          0,
          featureName
        ).then((res: any) => {
          const aux = res?.data?.items?.find((el: any) => el.isMedicoOnline);
          setMedicoOnlineEnabled(!!aux);
        });
      } catch (err: any) {}
    };
    getServices();
  }, [selectedBu]);

  //handles behaviour of the select all checkbox in networks
  const onChangeSelectAllFilters = (value: any) => {
    if (value) {
      let aux = network?.map((el: any) => {
        return el.code;
      });
      setNetworkChecked(aux);
      setSelectAllFilters(true);
    } else {
      setNetworkChecked([]);
      setSelectAllFilters(false);
    }
  };

  const processViewPrices = (categoryCode: number) => {
    switch (categoryCode) {
      case 1:
        if (labelsPrecos?.medicalNetwork_show_price_appointment === '1') {
          setShowPriceResults(true);
        } else {
          setShowPriceResults(false);
        }
        break;
      case 2:
        if (labelsPrecos?.medicalNetwork_show_price_exam === '1') {
          setShowPriceResults(true);
        } else {
          setShowPriceResults(false);
        }
        break;
      case 3:
        if (labelsPrecos?.medicalNetwork_show_price_surgery === '1') {
          setShowPriceResults(true);
        } else {
          setShowPriceResults(false);
        }
        break;
      case 4:
        if (labelsPrecos?.medicalNetwork_show_price_other === '1') {
          setShowPriceResults(true);
        } else {
          setShowPriceResults(false);
        }
        break;
    }
  };

  const nextStage = async (
    code: any,
    name: any,
    categoryCode: number,
    specialtyCode?: number
  ) => {
    setIsLoadingResults(true);
    setTriggeredViewMore(false);
    try {
      await getWithCustomHeaders(
        uriGetClinicProcedure(
          code,
          0,
          searchFields.locationName,
          finalNetworks
        ),
        headers
      ).then((res: any) => {
        setSearchResults(res?.data);
        setPaginationCode(code);
        setSearchClicked(name);
        setCurrentFilter('relevance');
        processViewPrices(categoryCode);
        setSelectedCategoryCode(categoryCode);
        setSelectedSpecialtyCode(specialtyCode || -1);
      });
    } catch (e: any) {
    } finally {
      setIsLoadingResults(false);
    }
  };

  const nextStageMedics = (code: any) => {
    setSelectedMedicCode(code);
    setTriggeredViewMore(false);
  };

  const loadMedicsFromSpeciality = (medic: any) => {
    setSelectedMedicCode(medic.code);
    setMedicDataFromSpeciality(medic);
    setLocalHistory([...localHistory, 'stage2Medics']);
  };

  const nextStageClinicsNotGrouped = (
    code: any,
    mappedObject: any,
    filter?: boolean
  ) => {
    setFilterTab(
      (filter ? filter : false) &&
        (selectedCategoryCode ===
          parseInt(labelsRede.medicalNetwork_appointments_code) ||
          selectedCategoryCode ===
            parseInt(labelsRede.medicalNetwork_exams_code))
    );
    setSelectedClinicCode(code);
    setSelectedClinicSection(mappedObject); //string with the value clinics optics or wellbeing to know where to search
    setTriggeredViewMore(false);
  };

  const nextStageClinics = async (nameHash: any, name: any) => {
    try {
      await getWithCustomHeaders(
        uriGetClinicGroup(
          nameHash,
          0,
          searchFields.locationName,
          finalNetworks
        ),
        headers
      ).then((res: any) => {
        setSearchResults(res?.data);
        setPaginationCode(nameHash);
        setSearchClicked(name);
        setCurrentFilter('relevance');
        setTriggeredViewMore(false);
      });
    } catch (e: any) {}
  };

  //handles pagination change/ordering
  const changePage = async (code: any, page: number, order: any) => {
    setIsLoadingResults(true);
    const filterOptionsRelevance =
      order === 'Relevância' || order === 'relevance';
    const filterOptionsAlpha = order === 'Ordem Alfabética' || order == 'name';
    const skip = page ? (page - 1) * 10 : 0;

    try {
      if (filterOptionsAlpha) {
        await getWithCustomHeaders(
          clinicClicked
            ? uriGetClinicGroupAlpha(
                code,
                skip,
                searchFields.locationName,
                finalNetworks
              )
            : uriGetClinicProcedureAlpha(
                code,
                skip,
                searchFields.locationName,
                finalNetworks
              ),
          headers
        ).then((res: any) => {
          setSearchResults(res?.data);
          setPaginationCode(code);
          setCurrentPage(page);
          setCurrentFilter(order);
          setIsLoading(false);
        });
      } else if (filterOptionsRelevance) {
        await getWithCustomHeaders(
          clinicClicked
            ? uriGetClinicGroup(
                code,
                skip,
                searchFields.locationName,
                finalNetworks
              )
            : uriGetClinicProcedure(
                code,
                skip,
                searchFields.locationName,
                finalNetworks
              ),
          headers
        ).then((res: any) => {
          setSearchResults(res?.data);
          setPaginationCode(code);
          setCurrentPage(page);
          setCurrentFilter(order);
        });
      }
    } catch (e: any) {
    } finally {
      setIsLoadingResults(false);
    }
  };

  const triggerAutoComplete = (value: any) => {
    setCountryDistrictFilled(!!value);
    setSearchFieldAutoComplete(value);
    if (value?.length >= 3) {
      let result: any[] = [];
      locations?.map((el: any) => {
        if ((el.includes(value) || el.toLowerCase().includes(value)) && value) {
          result.push(el);
        }
      });
      setSearchSuggestions(result);
    } else {
      setSearchSuggestions([]);
    }
  };

  const searchSuggestionOnClick = (value: any) => {
    setSearchFieldAutoComplete(value);
    setShowAutoComplete(false);
  };

  const onCheckboxChange = (value: any, el: any) => {
    //if clicked to check=true adds the checkbox code to the array of checked items
    if (value) {
      setNetworkChecked(networkChecked.concat(el));
      if (networkChecked.concat(el)?.length === network?.length) {
        setSelectAllFilters(true);
      }
    } else {
      //if clicked to check=false removes the checkbox code from the array of checked items
      //(also removes the checked from the select All if thats the case)
      setSelectAllFilters(false);
      let auxArray = networkChecked?.map((e: any) => {
        return e;
      });
      let aux = auxArray.indexOf(el);
      auxArray.splice(aux, 1);
      setNetworkChecked(auxArray);
    }
  };

  //used to check the value of the checkboxes
  const insideList = (code: any) => {
    const result = networkChecked.find((e: any) => e === code);
    return result ? true : false;
  };

  const handleHeaderResultsOnClick = () => {
    const aux = localHistory;
    if (localHistory[localHistory?.length - 1] === 'stage2') {
      setFilterTab(false);
      setSelectedCategoryCode(-1);
      setSelectedSpecialtyCode(-1);
      setPaginationCode(-1);
    }
    setLocalHistory([...aux.slice(0, aux?.length - 1)]);
  };

  const handleGoToMap = () => {
    setShouldShowMap(!shouldShowMap);
  };

  useEffect(() => {
    setMobileMode(window.screen.width < WINDOW_DIMENSION_LIMIT);
  }, [window.screen.width]);

  const handleKeypress = (e: any) => {
    //it triggers by pressing the enter key
    if (e.key === 'Enter' && enabledButton) {
      handleSubmit({search: currentSearch});
    }
  };

  const renderMedicOnlineBanner = () =>
    busFuncMap &&
    busFuncMap[selectedBu.buId]?.map((func: any) => {
      if (
        func?.isVisible &&
        functionalitiesAliasMap.services === func?.featureTemplateAlias
      ) {
        return (
          <div className="rede-banner-medico-online">
            <p
              className="rede-banner-medico-online-title"
              style={getColor('color')}>
              {
                labelsAppointments?.appointments_medicalNetwork_medicOnlineBanner_title
              }
            </p>
            <p className="rede-banner-medico-online-subtitle">
              {
                labelsAppointments?.appointments_medicalNetwork_medicOnlineBanner_subtitle
              }
            </p>
            <AppButton
              className="rede-banner-medico-online-button"
              variant="primary"
              onClick={() => {
                history.push('/consultas-online');
              }}>
              {
                labelsAppointments?.appointments_medicalNetwork_medicOnlineBanner_button
              }
            </AppButton>
          </div>
        );
      }
    });

  //header with the goback button used in every stage
  const returnHeader = (label1: any, label2: any, count: number) => {
    const hideSearchDetails =
      localHistory[localHistory?.length - 1] !== 'stage2Medics' &&
      localHistory[localHistory?.length - 1] !== 'stage2Clinics';
    return (
      <div className="header-results">
        <div className="return-to-previous-page-wrapper">
          <div onClick={handleHeaderResultsOnClick}>
            <ArrowIcon classNames="arrow-rotate-left" />
            <a
              className="app-header-bu-logo-opacity"
              style={{
                ...fonts.M,
                ...fonts.SemiBold,
                color: buStyles.primaryColor,
              }}>
              {labelsRede?.medicalNetwork_noResults_goBack}
            </a>
          </div>
          {localHistory[localHistory?.length - 1] === 'stage2' && (
            <div className="header-results-show-map" onClick={handleGoToMap}>
              <a
                className="app-header-bu-logo-opacity map-text"
                style={{
                  ...fonts.M,
                  ...fonts.SemiBold,
                  color: buStyles.primaryColor,
                }}>
                {shouldShowMap
                  ? labelsRede?.medicalNetwork_locations_view_list
                  : labelsRede?.medicalNetwork_locations_view_map}
              </a>
              {shouldShowMap ? (
                <Icon
                  className="app-header-bu-logo-opacity"
                  width="26"
                  height="26"
                  color={buStyles.primaryColor}
                  name={Icons.MENU}
                />
              ) : (
                <LocationPinIcon
                  color={buStyles.primaryColor}
                  width="22px"
                  height="18px"
                />
              )}
            </div>
          )}
        </div>
        {showMedicOnlineBanner && renderMedicOnlineBanner()}
        {hideSearchDetails && (
          <p style={{...fonts.SemiBold, ...fonts.M}} className="results-text">
            {`${count} ${labelsRede?.medicalNetwork_results1} `} <br />{' '}
            <span className="params">{`"${label1}" ${
              labelsRede?.medicalNetwork_results2
            } "${label2}" 
            ${labelsRede?.medicalNetwork_results2} ${
              finalNetworks?.length === network?.length
                ? `${labelsRede?.medicalNetwork_all_networks}`
                : `${finalNetworks?.length} ${
                    finalNetworks?.length === 1
                      ? labelsRede?.medicalNetwork_resultDesc1
                      : labelsRede?.medicalNetwork_resultDesc2.toLowerCase()
                  }`
            }`}</span>
          </p>
        )}
      </div>
    );
  };

  const handleOnSuggestionClick = async (value: any) => {
    setWhatYouSearchFilled(!!value);
    setCurrentSearch(value);
    handleSubmit({search: value});
  };

  const renderCheckboxNetworks = () => {
    return network?.map((el: any) => (
      <Row className="filter-options">
        <AppFormCheckboxField
          purposeId={oneTrust.purposeHealthData}
          name={el.name}
          value={insideList(el.code)}
          className="filter-checkbox"
          onChange={(value: any) => onCheckboxChange(value, el.code)}
          label={
            <label style={{...fonts.SM, ...fonts.Medium}}>{el.name}</label>
          }
          labelClass="checkboxes-label"
        />
      </Row>
    ));
  };

  const renderSearchSuggestions = () => {
    return searchSuggestions?.map((e: any) => (
      <Row className="search-map">
        <a
          onClick={() => searchSuggestionOnClick(e)}
          style={{
            ...fonts.M,
            color: buStyles?.primaryColor || colors.blue,
            ...fonts.Bold,
          }}>
          {e}
        </a>
      </Row>
    ));
  };

  const renderDropDownToggleAnchor = () => {
    return (
      <a
        id="network-dropdown-toggle" //uses the id to open the dropdown
        className="medical-network-selected-networks"
        style={{
          ...fonts.SM,
          ...fonts.Bold,
          color: buStyles?.primaryColor || colors.blue,
        }}>
        <ArrowIcon classNames="arrow-down" />
        {selectAllFilters
          ? labelsRede?.medicalNetwork_all_networks
          : `${labelsRede?.medicalNetwork_selected_networks} (${networkChecked?.length})`}
      </a>
    );
  };

  const renderSpainNetwork = () => {
    return (
      <Row className="spain-network-row">
        <a
          href={labelsRede?.medicalNetwork_spainNetworkURL}
          target={'_blank'}
          className="medical-network-spain"
          style={{
            ...fonts.SM,
            ...fonts.Bold,
            color: buStyles?.primaryColor || colors.blue,
          }}>
          {labelsRede?.medicalNetwork_spain_network}
        </a>
      </Row>
    );
  };

  const handleClickOnChangeCard = () => {
    const aux = busFuncMap[selectedBu.buId].find(
      (el: any) =>
        el.featureTemplateAlias === functionalitiesAliasMap.menuNetwork
    );
    if (aux) {
      aux.status === 'ACTIVE'
        ? window.location.replace('/network')
        : window.location.replace('/inicio');
    } else {
      window.location.replace('/');
    }
  };

  const handleToggleDropdown = () => {
    setShowDropDown(!showDropDown);
  };

  const handleCategoriesLoadMore = (res: any, code: number) => {
    let aux: any = {};
    const index = Object.keys(resultCategories).find(
      (el: any) => resultCategories[el].code === code
    );

    const indexRes = Object.keys(res.categories).find(
      (el: any) => res.categories[el].code === code
    );
    if (index && indexRes) {
      aux = resultCategories;
      aux[index].procedures = aux[index].procedures.concat(
        res.categories[indexRes].procedures
      );

      setResultCategories(aux);
    }
  };

  const getResultsLoadMore = async (
    take: any,
    categoryType: any,
    skip: any
  ) => {
    try {
      setTriggeredViewMore(false);
      await getWithCustomHeaders(
        uriGetNetworkSearch(
          currentSearch,
          searchFieldAutoComplete,
          networkChecked,
          take,
          skip
        ),
        headers
      ).then((response: any) => {
        let aux: any = {};
        const res = response?.data;
        switch (categoryType) {
          case 'Medicos':
            aux = medics;
            aux.medics = aux.medics.concat(res.medics.medics);
            setMedics(aux);
            break;
          case 'Clinicas':
            aux = clinics;
            aux.clinics = aux.clinics.concat(res.clinics.clinics);
            setClinics(aux);
            break;
          case 'Opticas':
            aux = optics;
            aux.clinics = aux.clinics.concat(res.optics.clinics);
            setOptics(aux);
            break;
          case 'BemEstar':
            aux = wellBeing;
            aux.clinics = aux.clinics.concat(res.wellBeing.clinics);
            setWellBeing(aux);
            break;
          case 'Exames': {
            handleCategoriesLoadMore(
              res,
              parseInt(labelsRede.medicalNetwork_exams_code)
            );
            break;
          }
          case 'Consultas': {
            handleCategoriesLoadMore(
              res,
              parseInt(labelsRede.medicalNetwork_appointments_code)
            );
            break;
          }
          case 'Cirurgias': {
            handleCategoriesLoadMore(
              res,
              parseInt(labelsRede.medicalNetwork_surgery_code)
            );
            break;
          }
          case 'Outros': {
            handleCategoriesLoadMore(
              res,
              parseInt(labelsRede.medicalNetwork_other_code)
            );
            break;
          }
          default:
            return;
        }
      });
    } catch (e: any) {
      if (e.status == 404) {
        setResultCount(0);
      }
    } finally {
      setTriggeredViewMore(true);
    }
  };

  const handleSubmit = async (values: any) => {
    setIsLoadingResults(true);
    setLocalHistory([]);
    const searchFields = {
      inputName: values.search,
      locationName: searchFieldAutoComplete,
    };
    setSearchFields(searchFields);
    consultasOnlineEnabled &&
      medicoOnlineEnabled &&
      medicBanner(searchFields.inputName || currentSearch);
    setFinalNetworks(networkChecked);

    try {
      await getWithCustomHeaders(
        uriGetNetworkSearch(
          values.search || currentSearch,
          searchFieldAutoComplete,
          networkChecked,
          6,
          0
        ),
        headers
      ).then((response: any) => {
        const res = response?.data;
        setResultCount(res.count);
        setFilterTab(false);
        setSelectedCategoryCode(-1);
        setSelectedSpecialtyCode(-1);
        setPaginationCode(-1);
        setResultCategories(
          filterActiveCategories(
            labelsRede.medicalNetwork_inactiveCategories,
            res.categories
          )
        );
        setMedics(res.medics);
        setClinics(res.clinics);
        setOptics(res.optics);
        setWellBeing(res.wellBeing);
        setAlternativeKeywords(res.alternativeKeywords);
      });
    } catch (e: any) {
      if (e.status == 404) {
        setResultCount(0);
      }
    } finally {
      setCurrentFilter('Relevância');
      setLocalHistory([...localHistory, 'stage1']);
      setCurrentPage(1);
      setShowDropDown(false);
      setIsLoadingResults(false);
      setReturnHeaderSearchField(values.search || currentSearch);
    }
  };

  const renderNewResults = () => {
    return (
      <NewResults
        numberOfResults={resultCount}
        nextStage={(code, name, categoryCode, specialtyCode?) =>
          nextStage(code, name, categoryCode, specialtyCode)
        }
        nextStageClinics={(nameHash, name) => nextStageClinics(nameHash, name)}
        handleOnSuggestionClick={(value) => handleOnSuggestionClick(value)}
        nextStageMedics={(code: any) => nextStageMedics(code)}
        nextStageClinicsNotGrouped={(code: any, selectedClinicSection: any) =>
          nextStageClinicsNotGrouped(code, selectedClinicSection)
        }
        getResultsLoadMore={(take: any, categoryType: any, skip: any) =>
          getResultsLoadMore(take, categoryType, skip)
        }
        searchFields={searchFields}
        categories={resultCategories}
        clinics={clinics}
        medics={medics}
        optics={optics}
        wellBeing={wellBeing}
        alternativeKeywords={alternativeKeywords}
        localHistory={localHistory}
        setLocalHistory={setLocalHistory}
      />
    );
  };

  const networkLocationsErrorPage = () => {
    return (
      <>
        <div className="medical-network-main-app-wrapper">
          <Column className="medical-network-container">
            <Row className="my-services-titlerow my-services-row">
              <Column className="medical-network-titlecolumn">
                <Header1
                  className="my-services-heading1"
                  style={{...fonts.XL, ...fonts.Bold}}>
                  {labelsRede?.medicalNetwork_title}
                </Header1>
                <Row></Row>
              </Column>
            </Row>
          </Column>
        </div>
      </>
    );
  };

  const mainContent = () => {
    return (
      <div className="medical-network-main-app-wrapper">
        <Column className="medical-network-container">
          <Row className="my-services-titlerow my-services-row">
            <Column className="medical-network-titlecolumn">
              <Header1
                className="my-services-heading1"
                style={{...fonts.XL, ...fonts.Bold}}>
                {labelsRede?.medicalNetwork_title}
              </Header1>
              <Row></Row>
              <div
                style={{...fonts.M}}
                className="medical-network-subtitle-container">
                <Row className="medical-network-subtitle-row">
                  {labelsRede?.medicalNetwork_subtitle1}
                </Row>
                <Row className="medical-network-subtitle-two-row">
                  {labelsRede?.medicalNetwork_subtitle2}
                </Row>
              </div>
            </Column>
          </Row>
          {networkError && (
            <ModalTemplate
              show={true}
              className="change-card-popup"
              size="lg"
              onHide={() => handleClickOnChangeCard()}
              hideFooter={true}
              cross={false}>
              <Row>
                <p
                  className="change-card-popup-title"
                  style={{...fonts.ML, ...fonts.Bold}}>
                  {' '}
                  {labelsRede?.medicalNetwork_popup_title}
                </p>
              </Row>
              <div className="popup-text-container center-text">
                <p style={{...fonts.M}}>
                  {labelsRede?.medicalNetwork_functionality_try_again_later}
                </p>
              </div>
              <Row className="change-card-popup-button-row">
                <AppButton
                  className="change-card-popup-button"
                  variant="secondary"
                  onClick={() => {
                    setNetworkError(false);
                    history.push('/inicio');
                  }}>
                  {labelsRede?.medicalNetwork_popup_ok}
                </AppButton>
              </Row>
            </ModalTemplate>
          )}
          {!isLoading && !isResponsive && (
            <Row className="medical-network-bgbox">
              <AppForm
                className="medical-network-form-container"
                initialValues={{
                  search: '',
                  countyDistrict: '',
                }}
                validationSchema={validationSchema}
                onValidation={(valid) => setValid(valid)}
                onSubmit={(values) => handleSubmit(values)}>
                <Row className="medical-network-search-form-wrapper">
                  <Column className="medical-network-search-selectbox">
                    <Row className="search-field-row">
                      <AppFormField
                        className="search-field"
                        name={'search'}
                        placeholder={labelsRede?.medicalNetwork_search}
                        value={currentSearch}
                        onChange={(value) => {
                          setWhatYouSearchFilled(!!value);
                          setCurrentSearch(value);
                        }}
                        onKeyPress={handleKeypress}
                      />
                    </Row>
                    <Row className="dropdown-row">
                      {!showDropDown ? (
                        renderDropDownToggleAnchor()
                      ) : (
                        <Column
                          id="network-dropdown"
                          className="selected-networks-dropdown-container">
                          <div className="dropdown-networks-container">
                            <Row
                              className="app-userlogout-row-container align-items-center clickable"
                              onClick={handleToggleDropdown}>
                              <ArrowIcon classNames="arrow-up" />
                              <span
                                style={{
                                  ...fonts.SM,
                                  ...fonts.Medium,
                                  ...fonts.Bold,
                                }}>
                                {labelsRede?.medicalNetwork_resultDesc2}
                              </span>
                            </Row>
                            <Row className="filter-options">
                              <AppFormCheckboxField
                                purposeId={oneTrust.purposeHealthData}
                                name="selectAll"
                                className="filter-checkbox"
                                value={selectAllFilters}
                                onChange={(value: any) =>
                                  onChangeSelectAllFilters(value)
                                }
                                label={
                                  <label
                                    style={{
                                      ...fonts.SM,
                                      ...fonts.Medium,
                                      ...fonts.Bold,
                                    }}>
                                    {
                                      labelsRede?.medicalNetwork_selectNetwork_all
                                    }
                                  </label>
                                }
                                labelClass="checkboxes-label"
                              />
                            </Row>
                            {renderCheckboxNetworks()}
                          </div>
                        </Column>
                      )}
                    </Row>
                  </Column>
                  <Column className="medical-network-county-district-selectbox">
                    {!showAutoComplete && (
                      <Row>
                        <AppFormField
                          onFocus={() => setShowAutoComplete(true)}
                          className="search-field"
                          name={'countyDistrict'}
                          id={'open-auto-complete'}
                          value={searchFieldAutoComplete}
                          placeholder={
                            labelsRede?.medicalNetwork_district_county
                          }
                          onKeyPress={handleKeypress}
                        />
                      </Row>
                    )}
                    {showAutoComplete && (
                      <div
                        id={'auto-complete'}
                        className="auto-complete-dropdown-container">
                        <Row className="app-userlogout-row-container">
                          <AppFormField
                            name={'searchFieldCountyDistrict'}
                            className="auto-complete-field"
                            onChange={(value) => triggerAutoComplete(value)}
                            value={searchFieldAutoComplete}
                            placeholder={
                              labelsRede?.medicalNetwork_district_county
                            }
                            onKeyPress={handleKeypress}
                            autoFocus
                          />
                        </Row>
                        <Row className="search-suggestions">
                          <span style={{...fonts.SM, color: colors.lightGrey}}>
                            {labelsRede?.medicalNetwork_suggestion}
                          </span>
                        </Row>
                        {renderSearchSuggestions()}
                      </div>
                    )}
                    {renderSpainNetwork()}
                  </Column>
                  <Column>
                    <AppFormSubmitButton
                      style={{backgroundColor: buStyles.primaryColor}}
                      title=""
                      className="search-button"
                      disabled={!enabledButton}>
                      <Icon
                        className="icon-search responsive-web"
                        style={
                          enabledButton
                            ? {backgroundColor: buStyles.primaryColor}
                            : {}
                        }
                        name={Icons.SEARCH}
                        color={
                          enabledButton ? colors.white : colors.backgroundGrey
                        }
                        width="27"
                        height="27"
                      />
                      <span className="responsive-mobile">Pesquisar</span>
                    </AppFormSubmitButton>
                  </Column>
                </Row>
              </AppForm>
            </Row>
          )}

          {!isLoading && isResponsive && (
            <Row className="medical-network-bgbox">
              <AppForm
                className="medical-network-form-container"
                initialValues={{
                  search: '',
                  countyDistrict: '',
                }}
                validationSchema={validationSchema}
                onValidation={(valid) => setValid(valid)}
                onSubmit={(values) => handleSubmit(values)}>
                <Row>
                  <Column className="medical-network-search-selectbox">
                    <Row>
                      <AppFormField
                        className="search-field"
                        name={'search'}
                        placeholder={'O que procura?'}
                        value={currentSearch}
                        onChange={(value) => {
                          setWhatYouSearchFilled(!!value);
                          setCurrentSearch(value);
                        }}
                        onKeyPress={handleKeypress}
                      />
                    </Row>
                    <Row className="dropdown-row">
                      {!showDropDown ? (
                        renderDropDownToggleAnchor()
                      ) : (
                        <Column
                          id="network-dropdown"
                          className="selected-networks-dropdown-container">
                          <div className="dropdown-networks-container">
                            <Row
                              className="filter-dropdown-row align-items-center"
                              onClick={handleToggleDropdown}>
                              <ArrowIcon classNames="arrow-up" />
                              <span style={{...fonts.SM, ...fonts.Medium}}>
                                {labelsRede?.medicalNetwork_resultDesc2}
                              </span>
                            </Row>
                            <Row className="filter-options">
                              <AppFormCheckboxField
                                purposeId={oneTrust.purposeHealthData}
                                name="selectAll"
                                className="filter-checkbox"
                                value={selectAllFilters}
                                onChange={(value: any) =>
                                  onChangeSelectAllFilters(value)
                                }
                                label={
                                  <label style={{...fonts.SM, ...fonts.Medium}}>
                                    {
                                      labelsRede?.medicalNetwork_selectNetwork_all
                                    }
                                  </label>
                                }
                                labelClass="checkboxes-label"
                              />
                            </Row>
                            {renderCheckboxNetworks()}
                          </div>
                        </Column>
                      )}
                    </Row>
                    {!showAutoComplete && !showDropDown && (
                      <Row>
                        <AppFormField
                          onFocus={() => setShowAutoComplete(true)}
                          name={'countyDistrict'}
                          id={'open-auto-complete'}
                          value={searchFieldAutoComplete}
                          onKeyPress={handleKeypress}
                          placeholder={
                            labelsRede?.medicalNetwork_district_county
                          }
                          onChange={(value) => {
                            setCountryDistrictFilled(!!value);
                          }}
                        />
                      </Row>
                    )}
                    {showAutoComplete && (
                      <div
                        id={'auto-complete'}
                        className="auto-complete-dropdown-container">
                        <Row className="app-userlogout-row-container">
                          <AppFormField
                            name={'searchFieldCountyDistrict'}
                            className="auto-complete-field"
                            onChange={(value) => triggerAutoComplete(value)}
                            value={searchFieldAutoComplete}
                            placeholder={
                              labelsRede?.medicalNetwork_district_county
                            }
                            onKeyPress={handleKeypress}
                            autoFocus
                          />
                        </Row>
                        <Row className="search-suggestions">
                          <span style={{...fonts.SM, color: colors.lightGrey}}>
                            {labelsRede?.medicalNetwork_suggestion}
                          </span>
                        </Row>
                        {renderSearchSuggestions()}
                      </div>
                    )}
                    {renderSpainNetwork()}
                  </Column>
                </Row>
                {!showDropDown && !showAutoComplete && (
                  <AppFormSubmitButton
                    title={labelsRede?.medicalNetwork_search_button}
                    disabled={!enabledButton}
                  />
                )}
              </AppForm>
            </Row>
          )}
          {(localHistory[localHistory?.length - 1] === 'stage1' ||
            triggeredViewMore) && (
            <>
              {returnHeader(
                returnHeaderSearchField,
                searchFields.locationName,
                resultCount
              )}
              {renderNewResults()}
            </>
          )}
          {localHistory[localHistory?.length - 1] === 'stage2' &&
            searchResults &&
            !isLoadingResults && (
              <>
                {returnHeader(
                  searchClicked,
                  searchFields.locationName,
                  searchResults.count
                )}
                <NewStage2
                  results={searchResults.clinics}
                  mobileMode={mobileMode}
                  count={searchResults.count}
                  precoEstimadoAtivo={precoEstimadoAtivo}
                  precoEstimadoFuncAtiva={precoEstimadoFuncAtiva}
                  currentPage={currentPage}
                  nextStageClinicsNotGrouped={(
                    code: any,
                    selectedClinicSection: any,
                    filtered?: boolean
                  ) =>
                    nextStageClinicsNotGrouped(
                      code,
                      selectedClinicSection,
                      filtered
                    )
                  }
                  changePage={(code, skip, order) =>
                    changePage(code, skip, order)
                  }
                  codeToPagination={paginationCode}
                  filterSelected={currentFilter}
                  localHistory={localHistory}
                  setLocalHistory={setLocalHistory}
                  showPrice={showPriceResults}
                  shouldShowMap={shouldShowMap}
                />
              </>
            )}
          {localHistory[localHistory?.length - 1] === 'stage2Medics' && (
            <>
              {returnHeader(null, null, 0)}
              <Stage2Medics
                mobileMode={mobileMode}
                medics={medics}
                precoEstimadoAtivo={precoEstimadoAtivo}
                precoEstimadoFuncAtiva={precoEstimadoFuncAtiva}
                selectedMedic={selectedMedicCode}
                network={networkChecked}
                showPrice={showPriceResults}
                nextStageClinicsNotGrouped={(
                  code: any,
                  selectedClinicSection: any
                ) => nextStageClinicsNotGrouped(code, selectedClinicSection)}
                localHistory={localHistory}
                setLocalHistory={setLocalHistory}
                medicData={medicDataFromSpeciality}
              />
            </>
          )}
          {localHistory[localHistory?.length - 1] === 'stage2Clinics' && (
            <>
              {returnHeader(null, null, 0)}
              <Stage2Clinics
                precoEstimadoAtivo={precoEstimadoAtivo}
                precoEstimadoFuncAtiva={precoEstimadoFuncAtiva}
                showPrice={showPriceResults}
                selectedClinic={selectedClinicCode}
                selectedClinicSection={selectedClinicSection}
                network={networkChecked}
                loadMedicData={loadMedicsFromSpeciality}
                setFilterTab={setFilterTab}
                filterTab={filterTab}
                selectedCode={paginationCode}
                selectedCategoryCode={selectedCategoryCode}
                selectedSpecialtyCode={selectedSpecialtyCode}
              />
            </>
          )}
          {(isLoading || isLoadingResults) && (
            <AppSpinner className="loading-spinner" />
          )}
        </Column>

        <ModalTemplate
          show={showChangeCard}
          className="change-card-popup"
          size="lg"
          onHide={() => handleClickOnChangeCard()}
          hideFooter={true}
          cross={true}>
          <Row>
            <p
              className="change-card-popup-title"
              style={{...fonts.ML, ...fonts.Bold}}>
              {' '}
              {labelsRede?.medicalNetwork_popup_title}
            </p>
          </Row>
          {precoEstimadoFuncAtiva ? (
            <div className="popup-text-container">
              <span style={{...fonts.M}}>
                {
                  labelsPrecos?.medicalNetwork_popup_estimated_price_description1
                }
              </span>
              <span style={{...fonts.M, ...fonts.Bold}}>
                {
                  labelsPrecos?.medicalNetwork_popup_estimated_price_description2
                }
              </span>
              <span style={{...fonts.M}}>
                {
                  labelsPrecos?.medicalNetwork_popup_estimated_price_description3
                }
              </span>
              <span
                className="change-card-popup-subtitle"
                style={{...fonts.M, ...fonts.Bold}}>
                {
                  labelsPrecos?.medicalNetwork_popup_estimated_price_description4
                }
              </span>
            </div>
          ) : (
            <>
              <span style={{...fonts.M}}>
                {labelsRede?.medicalNetwork_popup_description1}
              </span>
              <span
                className="change-card-popup-subtitle"
                style={{...fonts.M, ...fonts.Bold}}>
                {labelsRede?.medicalNetwork_popup_description2}
              </span>
            </>
          )}
          <Row className="change-card-popup-button-row">
            <AppButton
              className="change-card-popup-button"
              variant="secondary"
              onClick={() => handleClickOnChangeCard()}>
              {labelsRede?.medicalNetwork_popup_ok}
            </AppButton>
          </Row>
        </ModalTemplate>
      </div>
    );
  };

  const loadGoogleMapsScript = () => {
    return (
      <LoadScript
        id="script-loader"
        googleMapsApiKey={`${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`}>
        {mainContent()}
      </LoadScript>
    );
  };

  return (
    <>{medicalNetworkIsVisible ? loadGoogleMapsScript() : mainContent()}</>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  wizard,
  availableBus,
  globalStyles,
  titular,
  purposes,
  showCardModal,
  busFuncMap,
  consultasOnlineEnabled,
  accessToken,
  medicoOnlineEnabled,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  availableBus: availableBus.value,
  labelsRede: strings.value.pt.rede,
  labelsAppointments: strings.value.pt.appointments,
  labelsPrecos: strings.value.pt.redePrecos,
  oneTrust: strings.value.pt.oneTrust,
  wizard: wizard.value,
  buStyles: globalStyles.value,
  titular: titular.value,
  purposes: purposes.value,
  showCardModal: showCardModal.value,
  busFuncMap: busFuncMap.value,
  consultasOnlineEnabled: consultasOnlineEnabled.value,
  accessToken: accessToken.value,
  medicoOnlineEnabled: medicoOnlineEnabled.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setMedicoOnlineEnabled: (value: any) =>
    dispatch(setMedicoOnlineEnabled(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(NewMedicalNetwork)
);
